import { DealType } from '@search/filter-enums/enums/DealType';

export function offerSearchTextDealType({
    dealType
}: {
    dealType: DealType;
}) {
    switch (dealType) {
        case DealType.SELL:
            return 'купить';
        default:
            return 'снять';
    }
}

